var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-admin-wrap layout-sidebar-large"},[_c('Header'),_vm._v(" "),_c('sidebar'),_vm._v(" "),_c('div',{staticClass:"main-content-wrap sidenav-open d-flex flex-column"},[_c('div',{staticClass:"main-content"},[_c('router-view')],1),_vm._v(" "),_c('div',{staticClass:"flex-grow-1"}),_vm._v(" "),_c('Footer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68639e96","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main.vue
// module id = null
// module chunks = 